import { MutationTree } from 'vuex'
import { PronosticoHidricoEstacionState, StoreError } from '@/store/modules/pronostico-hidrico-estacion/types'
import { PronosticoHidricoEstacionApi } from '@/domain/entities/Api'

export const mutations: MutationTree<PronosticoHidricoEstacionState> = {
  PRONOSTICO_HIDRICO_ESTACION_FETCHED (state, payload: PronosticoHidricoEstacionApi[]) {
    state.error = { state: false }
    state.estacionResumen = payload
  },
  PRONOSTICO_HIDRICO_SET_API_RESUMEN (state, payload: string) {
    state.link_descarga = payload
  },
  PRONOSTICO_HIDRICO_ESTACION_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
